import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { premiumCalculatePost } from "../../../store/premiumCalculate/actions";
export var usePremiumCalculate = function (productCode, planCode, birthDate, gender) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingCalculate: state.PremiumCalculate.loadingCalculate,
        responseCalculate: state.PremiumCalculate.responseCalculate,
        errorCalculate: state.PremiumCalculate.errorCalculate,
    }); }), loadingCalculate = _a.loadingCalculate, responseCalculate = _a.responseCalculate, errorCalculate = _a.errorCalculate;
    var calculatePremium = useCallback(function (coverageAmount, paymentMode) {
        if (!birthDate || !gender || !paymentMode)
            return;
        if (!coverageAmount || Number(coverageAmount) <= 0)
            return;
        var resolvedPlanCode = (planCode === null || planCode === void 0 ? void 0 : planCode.includes("/"))
            ? planCode.split("/")[1]
            : planCode;
        var body = {
            productCode: productCode,
            planCode: resolvedPlanCode,
            inputData: {
                birthDate: birthDate,
                gender: gender,
                smokes: false,
                coverageAmount: Number(coverageAmount),
                paymentMode: paymentMode,
            },
        };
        dispatch(premiumCalculatePost(body));
    }, [dispatch, productCode, planCode, birthDate, gender]);
    return {
        responseCalculate: responseCalculate,
        loadingCalculate: loadingCalculate,
        errorCalculate: errorCalculate,
        calculatePremium: calculatePremium,
    };
};
